import styled from "styled-components";
import { Chart } from 'primereact/chart';


export const ChartCustom = styled(Chart)`
    /* padding: 0px 0px 0px 10px; */
    canvas { 
        /* height: 200px !important;
        width: 300px !important; */
        /* margin-right: -65px !important; */
    }
`